<div class="timer" (mousedown)="onMouseDown()" (mouseup)="onMouseUp()" (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()">
    <ng-container *ngIf="component.data.format == 'None'">
        {{component.data.count}}
    </ng-container>
    <ng-container
        *ngIf="component.data.format == 'm:ss' || component.data.format == 'h:mm:ss' || component.data.format == 'mm:ss' || component.data.format == 'hh:mm:ss' || component.data.format == 'd:h:m:ss' ">
        {{component.data.count | formatDuration : 's' : component.data.format}}
    </ng-container>
</div>